import React, { ReactElement } from 'react';
import { IHunterTireCardProps } from '../HunterTireCard/HunterTireCard';
import css from './HunterTireCardGrid.module.scss';

interface IHunterTireCardGridProps {
    children: ReactElement<IHunterTireCardProps>[];
}

export const HunterTireCardGrid: React.FC<IHunterTireCardGridProps> = React.memo((props) => <div className={css.hunterTireCardGrid}>{props.children}</div>);
